<template>
    <div class="d-flex align-center flex-1-1-0">
        <div :class="['card-container rounded-lg overflow-hidden', cardClassName]">
            <ticket-card-header />
            <ticket-card-data :travel-card-number="travelCardNumber" :class-name="dataClassName" :enable-divider="isNewCard" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ITicketCard } from '../../types';
import TicketCardHeader from './components/TicketCardHeader.vue';
import TicketCardData from './components/TicketCardData.vue';

const props = defineProps<ITicketCard>();

const dataClassName = props.isNewCard ? 'bg-black text-white d-flex' : 'text-secondary-light';
const cardClassName = props.isNewCard ? 'bg-bg-card' : 'bg-bg-old-card';
</script>
